import React, { useState, useEffect } from "react";
import { Col, Row, Typography, } from 'witmeg-ui-system'
import { useHistory } from 'react-router'
import "./HospitalityDefaultOrderPage.scss"
import { useSelector, useDispatch } from 'react-redux';
import { LOCAL_STORAGE_ITEMS_NAMES } from "../../../RestaurantWidget/utilities/helper/helper";
import { getCartItemsToCart, getFloorDetails, placeOrder } from "../../../RestaurantWidget/utilities/api/restaurantsService";
import { Select } from "antd";
import { setOrderData, setOrderEmpty, setSelectedOrderType } from "../../../../../../../redux/resturantWidgetSlice";
import locationIC from "../../assets/location.svg"
import arrow from "../../assets/images/down-arrow.svg"
import cardIc from "../../assets/card.svg"
import cashIc from "../../assets/cash.svg"
import cartIc from "../../assets/cart-gray.svg"
import { getRestaurantMenuSettingsData } from "../../../../../utilities/apiRequests/neutriPosServerRequests";
import { sendPaymentDetails } from "../../../RestaurantWidget/utilities/api/paymentService";
import HospitalityDefaultPaymentContainer from "../HospitalityDefaultPayment/HospitalityDefaultPaymentContainer";
import Footer from "../../components/Footer/Footer";
import IMAGE_PLACEHOLDER from "../../assets/images/Images/empty-placeholder.png"

const HospitalityDefaultOrderSummaryPage = () => {
    const restaurantDataState = useSelector((state) => state.resturantData);
    const companyDetails = useSelector((state) => state.companyData.companyDetails);
    const [floorData, setFloorData] = useState([])
    const [tables, setTables] = useState([])
    const [selectedFloor, setSelectedFloor] = useState(null)
    const [selectedTable, setSelectedTable] = useState(null)
    const { Option } = Select;
    const customerDetails = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_CUSTOMER_DETAILS) ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_CUSTOMER_DETAILS)) : {}
    const defaultDetails = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA) && JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA))
    const [dineInError, setDineInError] = useState(false)
    const [isLoading, setIsLoading] = useState("")
    const [isCollapsed, setIsCollapsed] = useState("closed")
    const [isCardPayment, setIsCardPayment] = useState(true)
    const [isOrderLoading, setIsOrderLoading] = useState(false)
    const [paymentTypes, setPaymentTypes] = useState([])
    const [isPaymentLoading, setIsPaymentLoading] = useState(false)


    const dispatch = useDispatch()
    let history = useHistory();
    const search = history.location.search;
    const params = new URLSearchParams(search);
    const redirectResult = params.get('redirectResult');

    const isCartDataAvailable = restaurantDataState.orderCartData && restaurantDataState.orderCartData.Items.length ? true : false;
    const orderID = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_CART_ORDER_ID) ? localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_CART_ORDER_ID) : ""
    const storeOrderLocalData = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA) ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)) : null
    const getPaymenttypes = async () => {
        const paymentSettings = await getRestaurantMenuSettingsData({
            SettingType: "PaymentMethods",
            CloudLocationID: storeOrderLocalData.cloudLocationID,
        })
        const paymentMethods = paymentSettings.map((type) => type.PaymentMethod);
        setPaymentTypes(paymentMethods);
        return paymentMethods;

    }
    const handlePaymentMethods = async () => {
        let types = await getPaymenttypes()
        if (types.length === 1 && types[0] === "card") {
            setIsCardPayment(true)
        } else {
            setIsCardPayment(false)
        }
    }
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    useEffect(() => {
        if (orderID === "" && customerDetails) {
            history.push("/")
        } else {
            handlePaymentMethods()

        }
    }, [])
    useEffect(() => {
        if (redirectResult) {
            sendPaymentDetailsRedirect()
            setIsCardPayment(true)
        }
    }, [])
    useEffect(() => {
        if (defaultDetails && defaultDetails.defaultOrderType === "table" && restaurantDataState.orderDetails.FulfillmentType === "DINE_IN") {
            console.log(defaultDetails.tableLocalId, "defaultDetails.tableLocalId")


            getFloorDetails().then((response) => {
                if (response) {
                    setFloorData(response)
                    let value = response.map((floor) =>
                        floor.Tables.map((table) => {
                            if (table.LocalID === defaultDetails.tableLocalId) {
                                console.log(table, "table")
                                let floorDataValue = {
                                    Id: floor.ID,
                                    Name: floor.ItemName.Translations.en,
                                    LocalReference: { Id: floor.LocalID }
                                }
                                let data = {
                                    TableID: table.ID,
                                    TableName: table.TableName,
                                    LocalReference: { Id: table.LocalID },
                                    Floor: floorDataValue
                                }
                                setSelectedFloor(floorDataValue)
                                setSelectedTable(data)
                                return data;
                            }
                            return null;
                        })
                    )
                        .flat()
                        .filter(Boolean)[0];
                    let updatedData = { ...restaurantDataState.orderDetails, FulfillmentType: restaurantDataState.orderDetails.FulfillmentType, DineIn: value }
                    dispatch(setOrderData(updatedData))
                }
            })
        }
    }, [])
    // useEffect(() => {
    //     if (restaurantDataState.orderDetails.FulfillmentType && restaurantDataState.orderDetails.FulfillmentType !== undefined) {
    //         let updatedData = { ...restaurantDataState.orderDetails, FulfillmentType: restaurantDataState.orderDetails.FulfillmentType }
    //         if (restaurantDataState.orderDetails.FulfillmentType === "DINE_IN") {
    //             getFloorDetails().then((response) => {
    //                 if (response) {
    //                     setFloorData(response)
    //                     let selectedFloorValue = response[0]
    //                     let floorValue = {
    //                         Id: selectedFloorValue.ID,
    //                         Name: selectedFloorValue.ItemName.Translations.en,
    //                         LocalReference: { Id: selectedFloorValue.LocalID }
    //                     }
    //                     setSelectedFloor(floorValue)
    //                     let Tables = response?.find((floor) => floor.ID === floorValue.Id)?.Tables
    //                     if (Tables !== undefined) {
    //                         let selected = Tables[0]
    //                         let tableValue = {
    //                             TableID: selected.ID,
    //                             TableName: selected.TableName,
    //                             LocalReference: { Id: selected.LocalID },
    //                             Floor: selectedFloor
    //                         }
    //                         setSelectedTable(tableValue)
    //                         setTables(Tables)
    //                     }
    //                 }
    //             })

    //         } else {
    //             updatedData = { ...updatedData, DineIn: {} }
    //         }
    //         dispatch(setOrderData(updatedData))
    //     }

    // }, [restaurantDataState.orderDetails.FulfillmentType])
    // useEffect(() => {
    //     setSelectedTable(null)
    //     setTables([])
    //     setTimeout(() => {
    //         if (floorData) {
    //             let Tables = floorData?.find((floor) => floor.ID === selectedFloor.Id)?.Tables
    //             if (Tables !== undefined) {
    //                 let selected = Tables[0]
    //                 let tableValue = {
    //                     TableID: selected.ID,
    //                     TableName: selected.TableName,
    //                     LocalReference: { Id: selected.LocalID },
    //                     Floor: selectedFloor
    //                 }
    //                 setSelectedTable(tableValue)
    //                 setTables(Tables)
    //             }
    //         }
    //     }, 0);
    // }, [selectedFloor, restaurantDataState.orderDetails.FulfillmentType])
    console.log(selectedFloor, selectedTable, "Asd")
    const getPrice = (
        basePrice
    ) => {
        let priceValue;
        switch (restaurantDataState.orderDetails.FulfillmentType) {
            case "DELIVERY_BY_REWARDCONSUMER":
                priceValue = basePrice.Delivery.FormattedText;
                break;
            case "DINE_IN":
                priceValue = basePrice.DineIn.FormattedText;
                break;
            case "TAKE_AWAY":
                priceValue = basePrice.TakeAway.FormattedText;
                break;
            default:
                priceValue = basePrice.Delivery.FormattedText;
                break;
        }
        return priceValue
    }
    const renderModifierGroups = (selectedGroup, item) => {
        return (
            <div>
                {selectedGroup.SelectedItems.map((selectedItem, index) => (
                    <span key={index}>
                        <span className="addon-title">
                            {selectedItem.Title.replace(/\.+$/, '')} <span className="qty-box">{Math.floor(selectedItem.Quantity.Amount / item.Quantity.Amount)}</span>
                        </span>
                        {selectedItem.SelectedModifierGroups && selectedItem.SelectedModifierGroups.length > 0 && (
                            <span>
                                {selectedItem.SelectedModifierGroups.map((nestedGroup, nestedIndex) => (
                                    <span key={nestedIndex}> {renderModifierGroups(nestedGroup, item)}</span>
                                ))}
                            </span>
                        )}
                        {index < selectedGroup.SelectedItems.length - 1 && <span>, </span>}
                    </span>
                ))}
            </div>
        );
    };

    const sendPaymentDetailsRedirect = () => {
        const paymentDetailsRequest = {
            cloudLocationID: storeOrderLocalData.cloudLocationID,
            reference: `Online-${storeOrderLocalData.cloudLocationID}-Ecom-${orderID}`,
            siteTransactionRef: orderID,
            store: `Ecommerce_${storeOrderLocalData.cloudLocationID}`,
            countryCode: "GB",
            paymentDetailInput: {
                redirectResult: redirectResult

            },
            shopperReference: localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID),

        }
        setIsPaymentLoading(true)
        sendPaymentDetails(paymentDetailsRequest, companyDetails.PaymentIntegration.IntegrationData.Client_Key).then((response) => {
            if (response) {
                if (response.resultCode && response.resultCode === "Authorised") {
                    const oid = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_CART_ORDER_ID)
                    history.push(`/order/success/${oid}`)
                    dispatch(setOrderEmpty())
                    setIsOrderLoading(false)
                    setIsPaymentLoading(false)
                    dispatch(setSelectedOrderType(""))
                } else {
                    history.push(`/order/failed`)
                }
            } else {
                history.push(`/order/failed`)
            }
        })

    }
    const placeCartOrder = (type) => {
        if (restaurantDataState.orderCartData.Items.length > 0) {
            setIsOrderLoading(true)
            setIsPaymentLoading(true)
            let customerData = [{ ...restaurantDataState.orderDetails.Customers[0], ...customerDetails }]
            let updatedData = {
                ...restaurantDataState.orderDetails, Customers: customerData, FulfillmentType: restaurantDataState.orderDetails.FulfillmentType, DineIn: selectedTable ? selectedTable : {}, OrderType
                    :
                    "MENU", PaymentType: type
            }

            placeOrder(updatedData).then((response) => {
                if (response) {
                    const oid = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_CART_ORDER_ID)
                    history.push(`/order/success/${oid}`)
                    dispatch(setOrderEmpty())
                    setIsOrderLoading(false)
                    setIsPaymentLoading(false)
                    dispatch(setSelectedOrderType(""))
                }
            }).catch((error) => {
                setIsOrderLoading(false)
                history.push(`/order/failed`)
            })

        }
    }



    return (
        <div className='HospitalityDefaultOrderPage '>
            {isPaymentLoading &&
                <div className="overlayer" ><div className="order-placing">Please wait your order in progress ...</div></div>
            }
            <div className="Order-confirmation">
                <div className="Order-confirmation-header">
                    <div className="header-text-cont">Checkout</div>

                </div>
                <div className="Order-confirmation-inner">
                    <div className="eco-mb-16 Order-confirmation-inner-left ">
                        {restaurantDataState.orderDetails.FulfillmentType === "DELIVERY_BY_REWARDCONSUMER" ? <div className="order-form-summary  eco-mb-36">
                            <div className="order-form-container">
                                <div className="form-header-text">Delivery Address</div>
                                <div className="address-conatinar">
                                    <div className="address-conatinar-left">
                                        <img className="loc-cont" alt="" src={locationIC} />
                                        <div className="customer-details-cont">
                                            <div className="customer-name-cont">
                                                <div className="name-text">{customerDetails?.Name?.FirstName} {customerDetails?.Name?.LastName}</div>
                                                <div className="address-tag">Main Address</div>
                                            </div>
                                            <div className="phone-number">{customerDetails.Contact.PinCode} {customerDetails.Contact.Number}</div>
                                            <div className="address">{customerDetails?.DeliveryAddress?.AddressLine1} {customerDetails?.DeliveryAddress?.StateProvinceRegion}, {customerDetails?.DeliveryAddress?.Country} {customerDetails?.DeliveryAddress?.PostZipCode} </div>
                                        </div>
                                    </div>
                                    <div className="address-conatinar-right">
                                        <a href={'/order/checkout'}>Edit Address</a>
                                    </div>
                                </div>
                            </div>
                        </div> :
                            <div className="order-form-summary  eco-mb-36">
                                <div className="order-form-container">
                                    <div className="form-header-text">Billing Address</div>
                                    <div className="address-conatinar">
                                        <div className="address-conatinar-left">
                                            <img className="loc-cont" alt="" src={locationIC} />
                                            <div className="customer-details-cont">
                                                <div className="customer-name-cont">
                                                    <div className="name-text">{customerDetails?.Name?.FirstName} {customerDetails?.Name?.LastName}</div>
                                                    <div className="address-tag">Main Address</div>
                                                </div>
                                                <div className="phone-number">{customerDetails.Contact.PinCode} {customerDetails.Contact.Number}</div>
                                                <div className="address">                                            {customerDetails?.BillingAddress?.AddressLine1} {customerDetails?.BillingAddress?.StateProvinceRegion}, {customerDetails?.BillingAddress?.Country} {customerDetails?.BillingAddress?.PostZipCode} </div>

                                            </div>
                                        </div>
                                        <div className="address-conatinar-right">
                                            <a href={'/order/checkout'}>Edit Address</a>
                                        </div>
                                    </div>
                                </div>
                            </div>}

                        {restaurantDataState.orderDetails.FulfillmentType === "DINE_IN" && <div className="order-form-summary">

                            <div className="order-form-container">
                                <div className="form-header-text">Selected Table</div>

                                <div className="floor-dropdown">
                                    <Row gutter={[16, 16]}>
                                        <Col lg={6} className="floor-drop-container">
                                            <div className="label">Floor</div>
                                            <div>{selectedFloor?.Name}</div>
                                            {/* <Select className="select-floor"
                                                onChange={(id) => {
                                                    let selected = floorData.find((floor) => floor.ID === id)
                                                    let floorValue = {
                                                        Id: selected.ID,
                                                        Name: selected.ItemName.Translations.en,
                                                        LocalReference: { Id: selected.LocalID }
                                                    }
                                                    setSelectedFloor(floorValue)
                                                    setDineInError(false)
                                                }}
                                                value={selectedFloor ? selectedFloor.Name : ""}
                                            >
                                                {floorData && floorData?.map((floor, key) => {
                                                    return (
                                                        <Option value={floor.ID} key={key}>
                                                            {floor.ItemName.Translations.en}
                                                        </Option>
                                                    )
                                                }
                                                )}
                                            </Select> */}
                                        </Col>
                                        <Col lg={6} className="floor-drop-container">
                                            <div className="label">Table</div>
                                            <div>{selectedTable?.TableName}</div>
                                            {/* {tables.length > 0 && <>
                                                <div className="label">Table</div>
                                                <Select className="select-floor"
                                                    onChange={(id) => {
                                                        let selected = tables.find((table) => table.ID === id)
                                                        let tableValue = {
                                                            TableID: selected.ID,
                                                            TableName: selected.TableName,
                                                            LocalReference: { Id: selected.LocalID },
                                                            Floor: selectedFloor
                                                        }
                                                        setSelectedTable(tableValue)
                                                        setDineInError(false)

                                                    }}
                                                    value={selectedTable ? selectedTable.TableName : ""}
                                                >
                                                    <Option value=''>
                                                    </Option>
                                                    {tables && tables?.map((table, key) => {
                                                        return (
                                                            <Option value={table.ID} key={key}>
                                                                {table.TableName}
                                                            </Option>
                                                        )
                                                    }
                                                    )}
                                                </Select>
                                            </>
                                            } */}
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </div>}
                        <div className="order-form-summary-payment">
                            <div className="order-form-container">
                                <div className="form-header-text">Payment Options</div>
                                {paymentTypes.includes("cash") && <div className="payment-method" onClick={() => { setIsCardPayment(false) }}>
                                    {isCardPayment ? <div className="radio-btn" /> :
                                        <div className="radio-btn-selected">
                                            <div className="radio-btn-selected-inner" />
                                        </div>}
                                    <div className="itm-cont"><img alt="" src={cashIc} /></div>
                                    Cash </div>}
                                {paymentTypes.includes("card") && <div className="payment-method-2" onClick={() => { setIsCardPayment(true) }}>
                                    {!isCardPayment ? <div className="radio-btn" /> :
                                        <div className="radio-btn-selected">
                                            <div className="radio-btn-selected-inner" />
                                        </div>}
                                    <div className="itm-cont"><img alt="" src={cardIc} /></div>
                                    Card   </div>}
                                {isCardPayment && companyDetails.PaymentIntegration && companyDetails.PaymentIntegration.
                                    IntegrationName === "Wittally" && !redirectResult && <HospitalityDefaultPaymentContainer selectedTable={selectedTable} />}
                            </div>
                        </div>
                    </div>
                    <div className="Order-confirmation-inner-right">
                        {isCartDataAvailable ? <div className="order-form-summary">
                            <div className="order-form-container">
                                <div id="orderCart">

                                    <div className="form-header-text">Order Summary</div>
                                    {isCartDataAvailable ?
                                        <>
                                            <div className="header-conater"><div className="header-conater-left">
                                                <img alt="" src={cartIc} />
                                                <div className="form-header-text-cont">Cart Items</div>
                                                <div className="text-sub ">({restaurantDataState.orderCartData.Items.length}  {restaurantDataState.orderCartData.Items.length === 1 ? "item" : "items"})</div></div>
                                                <div className="header-conater-right"><img alt="" src={arrow} className={`arrow-${isCollapsed}`} onClick={() => {
                                                    if (isCollapsed === "open") {
                                                        setIsCollapsed("closed")
                                                    } else {
                                                        setIsCollapsed("open")
                                                    }
                                                }} /></div></div>
                                            {isCollapsed === "open" && <div className="order-cart-list" >
                                                {isCartDataAvailable && restaurantDataState.orderCartData.Items.map((item, index) => {
                                                    const _hasAddons = item.SelectedModifierGroups.length > 0;
                                                    return (
                                                        <div className="order-cart-item" key={index}>
                                                            <div className="order-cart-item-left">
                                                                <div className="cart-item-image-cont">

                                                                    <Typography
                                                                        style={{ backgroundImage: `url(${item.PictureURL !== "" ? item.PictureURL : IMAGE_PLACEHOLDER})`, objectFit: item.PictureURL === "" ? "fill" : "" }}
                                                                        className="cart-item-image">
                                                                    </Typography>
                                                                </div>
                                                                <div className='item-details-container-left'>
                                                                    <div className='item-cart-title truncate-text'>{item.Title}</div>
                                                                    <div className="modifiers-text">
                                                                        {_hasAddons && item.SelectedModifierGroups.map((selectedGroup, index) => (
                                                                            <span key={index}> {renderModifierGroups(selectedGroup, item)} </span>
                                                                        ))}
                                                                    </div>
                                                                    <div className='item-cart-price'>  {isLoading === item.ID ? <div className="skeleton-box eco-skeleton-price" style={{ color: "transparent", height: "20px" }}>{getPrice(item.PriceInfo.TotalPrice)}XXX</div>
                                                                        : getPrice(item.PriceInfo.TotalPrice)}</div>
                                                                </div>
                                                            </div>
                                                            <div className="order-cart-item-right">
                                                                <div className="qty-container">
                                                                    {item.Quantity.Amount}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </div>}

                                        </>
                                        :
                                        <div className="empty-cart">
                                            <div className="empty">
                                                <div className="empty-text  eco-mb-24"> No cart items</div>
                                                <div className="custom-btn-order" onClick={() => {
                                                    history.push("/")
                                                }}>Continue Shopping
                                                </div>

                                            </div>
                                        </div>}



                                    <div className="price-list">
                                        <div className="form-header-text">Order Total</div>
                                        <div className="price-list-inner">
                                            <div className="price-list-inner-left">Sub total</div>
                                            <div className="price-list-inner-right">    {restaurantDataState.orderDetails.Payment.
                                                PaymentDetail.OrderTotal.Net.Formatted}</div>

                                        </div>
                                        {restaurantDataState?.orderDetails?.Payment.
                                            PaymentDetail?.Fee?.Details?.map((fee, key) => {
                                                return (
                                                    <div className="price-list-inner" key={key}>
                                                        <div className="price-list-inner-left">{fee.Description}</div>
                                                        <div className="price-list-inner-right">
                                                            {fee.Amount.DisplayAmount}
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                    </div>
                                    <div className="price-list">
                                        <div className="price-list-inner-total" >
                                            <div className="total-value-text ">Total Price</div>
                                            <div className="total-value-text ">
                                                {restaurantDataState.orderDetails.Payment.
                                                    PaymentDetail.OrderTotal.Gross.Formatted}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {!isCardPayment && paymentTypes.length !== 0 && <div className="custom-btn-order" onClick={() => {
                                    let customerData = [{ ...restaurantDataState.orderDetails.Customers[0], ...customerDetails }]
                                    let updatedData = {
                                        ...restaurantDataState.orderDetails, Customers: customerData, FulfillmentType: restaurantDataState.orderDetails.FulfillmentType, DineIn: selectedTable ? selectedTable : {}, OrderType
                                            : "MENU"
                                    }
                                    if (restaurantDataState.orderDetails.FulfillmentType === "DINE_IN" && Object.keys(updatedData.DineIn).length === 0) {
                                        setDineInError(true)
                                    } else {
                                        setDineInError(false)
                                        dispatch(setOrderData(updatedData))
                                        if (!isOrderLoading) {
                                            placeCartOrder("CASH_ON_DELIVERY")
                                        }
                                    }

                                }}>Confirm and Place Order</div>}
                                {dineInError && <Typography className="error-text">*Select a table and floor to continue</Typography>}
                                {redirectResult && <div className="custom-btn-order">Payment Inprocess</div>}
                            </div>
                        </div> : ""}
                    </div>
                </div>

            </div >
            <div className="footer-order">
                <Footer />

            </div>
        </div >
    )

}
export default HospitalityDefaultOrderSummaryPage